import React from 'react'
import AddressInformationForm from './AddressInformationForm'
import { Formik, Form } from 'formik'
import effects from 'app/effects/effects'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'
import { prop } from 'ramda'
import { addressMappingToApi } from '../mapping/profileMapping'
import { useFormContext, TEXT_200_MAX, TEXT_10_MAX } from '../FormProvider'
import * as Yup from 'yup'

const validationSchema = (formatMessage) => {
  return Yup.object({
    physicalStreetAddress1: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    physicalStreetAddress2: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    physicalCityName: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    physicalProvinceName: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    physicalPostalCode: Yup.string().max(
      TEXT_10_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_10_MAX },
      ),
    ),
    mailingStreetAddress1: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    mailingStreetAddress2: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    mailingCityName: Yup.string().max(
      TEXT_200_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_200_MAX },
      ),
    ),
    mailingPostalCode: Yup.string().max(
      TEXT_10_MAX,
      formatMessage(
        { id: 'maximum.characters.allowed' },
        { limit: TEXT_10_MAX },
      ),
    ),
  })
}

export default ({ initailValue, subscriber, countries, refetchData }) => {
  const subscriberId = prop('id', subscriber)
  const dispatch = useDispatch()
  const { onAddressChange, onAddressReset } = useFormContext()
  const { formatMessage } = useIntl()
  const updateGeneralInfo = (
    values,
    { resetForm, setSubmitting, setFieldError },
  ) => {
    const info = { type: 'address', payload: addressMappingToApi(values) }

    effects.apis
      .updateProfileDetailOfSubscriber({ subscriberId, info })
      .then(() => {
        setSubmitting(false)
        resetForm({ values })
        onAddressReset()
        refetchData(subscriberId)
        dispatch(
          MessageAlert.showSuccess({
            message: formatMessage({ id: 'message.alert.success' }),
          }),
        )
      })
      .catch((error) => {
        setSubmitting(false)
        const errorCode = error?.response?.data?.details?.code
        if (errorCode === 403) {
          dispatch(
            MessageAlert.showError({
              message: formatMessage({ id: 'error.permission.denied' }),
            }),
          )
        } else if (errorCode === 618) {
          setFieldError(
            'uniqueId',
            formatMessage({ id: 'uniqueId.already.exist' }),
          )
        } else {
          dispatch(
            MessageAlert.showError({
              message: formatMessage({ id: 'message.alert.error' }),
            }),
          )
        }
      })
  }

  return (
    <div className="w-full">
      <Formik
        initialValues={initailValue}
        validationSchema={validationSchema(formatMessage)}
        onSubmit={updateGeneralInfo}
      >
        <Form>
          <AddressInformationForm
            subscriber={subscriber}
            countries={countries}
            onAddressChange={onAddressChange}
            onAddressReset={onAddressReset}
          />
        </Form>
      </Formik>
    </div>
  )
}
